"use client";

import React from "react";
import { Code, Cpu, TrendingUp } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
const pillars = [{
  title: "Baumfällung & Wurzelentfernung\xA0",
  description: "Sichere Fällungen auf engstem Raum und professionelle Wurzelstockentfernung. Wir garantieren höchste Sicherheit und eine besenreine Übergabe.",
  icon: Code,
  image: "https://balanced-monster.10web.cloud/wp-content/uploads/2026/05/photo_2026-05-13_12-46-59.jpg?v=321kx5h3q0l",
  href: "https://baumpflege-straesser.de/fallung-wurzeln/"
}, {
  title: "Pflege & Freischnitt",
  description: "Fachgerechte Baumpflege, Totholzentfernung und Gebäudefreischnitt. We erhalten die Vitalität Ihrer Bäume und schützen Ihre Bausubstanz.",
  icon: Cpu,
  image: "https://balanced-monster.10web.cloud/wp-content/uploads/2026/05/ChatGPT-Image-6.-Mai-2026-12_35_06.png?v=ho8v17o49al",
  href: "https://baumpflege-straesser.de/pflege-freischnitt/"
}, {
  title: "Baumhausbau & Baubegleitung",
  description: "Individueller Baumhausbau und fachkundige Baubegleitung. Wir realisieren Träume in den Kronen und schützen Bäume bei Bauprojekten.",
  icon: TrendingUp,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642178/img/treehouse.png",
  href: "https://baumpflege-straesser.de/bau-begleitung/"
}];
export default function DigitalArchitecturePillars() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="224549" id="unsere-kernkompetenzen" className="bg-background text-foreground py-24 px-4 md:px-8 relative overflow-hidden">
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-primary/10 rounded-full blur-[120px] pointer-events-none" />

      <div ref={ref} className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-16 md:mb-24">
          <h2 className="font-default text-4xl md:text-5xl font-bold mb-6 tracking-tight">
            Unsere Kernkompetenzen
          </h2>
          <p className="font-sans text-muted-foreground max-w-2xl mx-auto text-lg md:text-xl">Professionelle Baumpflege in Hamburg, Ahrensburg und Schleswig Holstein. Sicherheit, Präzision und Leidenschaft für Ihr Grün.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {pillars.map((pillar, i) => {
          const Icon = pillar.icon;
          return <Link key={i} to={pillar.href} className="block group">
                <Card data-index={i} className={`cursor-pointer bg-card/30 backdrop-blur-xl border-border/40 overflow-hidden transition-all duration-500 group-hover:-translate-y-2 group-hover:border-primary/50 group-hover:shadow-2xl group-hover:shadow-primary/20 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
              transitionDelay: `${i * 150}ms`
            }}>
                  <CardHeader className="text-center pt-12 pb-6">
                    {}
                    <div className="mx-auto w-24 h-24 rounded-2xl bg-gradient-to-br from-primary/20 via-primary/5 to-transparent border border-primary/30 flex items-center justify-center mb-8 shadow-inner transition-transform duration-500 group-hover:scale-110 group-hover:from-primary/30 overflow-hidden">
                      {i === 0 || i === 1 || i === 2 ? <img src={pillar.image} data-wvc-srcset={`${pillar.image}-wvc-srcset`} data-wvc-sizes={`${pillar.image}-wvc-sizes`} alt={pillar.title} className="w-full h-full text-primary drop-shadow-md object-cover" loading="lazy" /> : <Icon className="w-12 h-12 text-primary drop-shadow-md" strokeWidth={1.5} />}
                    </div>
                    <CardTitle className="font-default text-2xl md:text-3xl tracking-tight">
                      {pillar.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="text-center pb-12 px-8">
                    <CardDescription className="font-sans text-base md:text-lg text-muted-foreground leading-relaxed">
                      {pillar.description}
                    </CardDescription>
                  </CardContent>
                </Card>
              </Link>;
        })}
        </div>
      </div>
    </section>;
}